import React from "react";

function IconSkypeMeeting() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        d="M10.037 15.417c-3.007 0-4.38-1.523-4.38-2.64-.001-.267.109-.522.303-.705a.977.977 0 01.724-.264c1.288 0 .95 1.92 3.353 1.92 1.227 0 1.948-.735 1.948-1.425 0-.415-.238-.89-1.048-1.08l-2.682-.672c-2.155-.545-2.53-1.736-2.53-2.842 0-2.293 2.11-3.123 4.118-3.123 1.85 0 4.05 1.016 4.05 2.391 0 .593-.498.91-1.076.91-1.1 0-.915-1.535-3.126-1.535-1.1 0-1.678.513-1.678 1.23s.856.96 1.606 1.123l1.979.444c2.17.487 2.747 1.752 2.747 2.964 0 1.864-1.45 3.304-4.311 3.304h.003zm8.301-3.944c.086-.49.13-.985.128-1.482a8.403 8.403 0 00-3.01-6.474A8.502 8.502 0 008.533 1.66 5.003 5.003 0 006.035 1a5.07 5.07 0 00-4.356 2.519 5.014 5.014 0 00-.016 5.011 8.399 8.399 0 002.33 7.453 8.504 8.504 0 007.48 2.356 5 5 0 002.494.661 5.07 5.07 0 004.354-2.518c.9-1.548.906-3.455.017-5.01z"
        fill="#0078D7"
      />
    </svg>
  );
}

export default IconSkypeMeeting;
